import { Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { i18nKeys } from '../../app.i18n'

import { ToastPayload } from '../../shared'

export function createErrorToast(message: any): ToastPayload {
  if (message && message.response && message.response.status && message.response.status === 412) {
    const reloadText = i18nKeys.core.common.etagvalidationError

    return { message: reloadText, icon: IconNames.ERROR, intent: Intent.DANGER } as ToastPayload
  }

  if (message && message.response && message.response.status && message.response.status === 410) {
    const reloadText = i18nKeys.frontFace.goals.menu.convertError

    return { message: reloadText, icon: IconNames.ERROR, intent: Intent.WARNING } as ToastPayload
  }

  if (message && message.response && message.response.status && message.response.status === 409) {
    const msg = i18nKeys.admin.bonusPeriod.error.overlapingBp

    return { message: msg, icon: IconNames.ERROR, intent: Intent.DANGER } as ToastPayload
  }

  if (message && message.response && message.response.data && message.response.data.message) {
    return {
      message: message.response.data.message,
      icon: IconNames.ERROR,
      intent: Intent.DANGER,
    } as ToastPayload
  }

  return { message, icon: IconNames.ERROR, intent: Intent.DANGER } as ToastPayload
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/toast.ts